/**
 * FAQ Page
 */

import {
  ContentBlock,
  Box,
  Accordion,
  AccordionItem,
} from 'braid-design-system';
import type React from 'react';

import { PageHead } from '../../components/PageHead/PageHead';
import { buildFaqPageJsonLd } from '../../constants/jsonLd';
import { faqItems } from '../../data/faqItems';

import * as styles from './FAQ.css';

export const FAQ: React.FC = () => (
  <ContentBlock width="large">
    <PageHead
      title="FAQ"
      description="Frequently asked questions about Fae Forest fairy doors, STL files, printing, and custom orders."
      path="/faq"
      jsonLd={buildFaqPageJsonLd(faqItems)}
    />
    <Box paddingY="large">
      <div className={styles.container}>
        <h1 className={styles.heading}>Frequently Asked Questions</h1>
        <p className={styles.description}>
          Everything you need to know about our fairy garden miniatures,
          printing, and custom work.
        </p>
        <Accordion>
          {faqItems.map((item) => (
            <AccordionItem key={item.q} label={item.q}>
              {item.a}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Box>
  </ContentBlock>
);
